import { all } from 'redux-saga/effects';
import authSaga from '../auth/authSaga'; // Import your auth saga
import voiceEntrySaga from '../voiceEntry/voiceEntrySaga';
import cameraEntrySaga from '../cameraEntry/cameraEntrySaga'; // Import your camera entry saga
import layoutSaga from '../layout/saga';
import LayoutSaga from '../layout/saga';
// import maiActionSaga from '../maiAction/maiActionSaga'; // Import your actions saga
// import contactsSaga from '../contacts/contactSaga';
// import debugLogsSaga from '../DebugLogs/debugLogsSaga';
import roomBookingSaga from '../roomBooking/roomBookingSaga';
import uiChatSaga from '../uiChatReducer/uiChatSaga';
import bookingAvailabilitySaga from '../bookingAvailability/bookingAvailabilitySaga';
import hotelSaga from '../hotel/hotelSaga';
import hotelStaffSaga from '../hotelStaff/hotelStaffSaga';

export default function* rootSaga() {
    yield all([
        authSaga(),
        layoutSaga(),
        // maiActionSaga(),
        // contactsSaga(),
        // debugLogsSaga()
        // Add more sagas here if 
        voiceEntrySaga(),
        cameraEntrySaga(),
        roomBookingSaga(),
        uiChatSaga(),
        bookingAvailabilitySaga(),
        hotelSaga(),
        hotelStaffSaga()
    ]);
}
